import { RegisterClosureInfoController as controller } from './register-closure-info.controller'
import template from './register-closure-info.html'

/**
 * Provides summary of register closure information
 *
 * @type {component}
 */
export const RegisterClosureInfoComponent = {
  bindings: {
    registerClosure: '<',
  },
  controller,
  template,
}
